import BaseDto from '../../_common/BaseDto';

class TemplateVariablesResponseDtoBuilder {
    constructor() {
        this.uuid = undefined;
        this.templateType = undefined;
        this.flowType = undefined;
        this.skillId = undefined;
        this.variables = undefined;
        this.contentExample = undefined;
        this.language = undefined;
        this.dateCreated = undefined;
        this.dateUpdated = undefined;
    }

    withUuid(uuid) {
        this.uuid = uuid;
        return this;
    }

    withTemplateType(templateType) {
        this.templateType = templateType;
        return this;
    }

    withFlowType(flowType) {
        this.flowType = flowType;
        return this;
    }

    withSkillId(skillId) {
        this.skillId = skillId;
        return this;
    }

    withVariables(variables) {
        this.variables = variables;
        return this;
    }

    withContentExample(contentExample) {
        this.contentExample = contentExample;
        return this;
    }

    withLanguage(language) {
        this.language = language;
        return this;
    }

    withDateCreated(dateCreated) {
        this.dateCreated = dateCreated;
        return this;
    }

    withDateUpdated(dateUpdated) {
        this.dateUpdated = dateUpdated;
        return this;
    }

    build() {
        return new TemplateVariablesResponseDto(this);
    }
}

class TemplateVariablesResponseDto extends BaseDto {
    constructor(builder) {
        super();
        this.uuid = builder.uuid;
        this.templateType = builder.templateType;
        this.flowType = builder.flowType;
        this.skillId = builder.skillId;
        this.variables = builder.variables;
        this.contentExample = builder.contentExample;
        this.language = builder.language;
        this.dateCreated = builder.dateCreated;
        this.dateUpdated = builder.dateUpdated;
    }

    static get Builder() {
        return TemplateVariablesResponseDtoBuilder;
    }
}

export default TemplateVariablesResponseDto;
